import { render, staticRenderFns } from "./ViewGateInfo.vue?vue&type=template&id=1b6319ec&"
import script from "./ViewGateInfo.vue?vue&type=script&lang=js&"
export * from "./ViewGateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports